export const EMBED_SCRIPT_SRC = 'https://cdn.docuseal.com/js/form.js';

let loadPromise = null;

// Loads the DocuSeal embed script once; it registers the <docuseal-form>
// custom element used by the document signing question.
export const loadDocusealEmbed = () => {
  if (window.customElements && window.customElements.get('docuseal-form')) {
    return Promise.resolve();
  }

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = EMBED_SCRIPT_SRC;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        loadPromise = null;
        reject(new Error('Could not load the DocuSeal signing form'));
      };
      document.head.appendChild(script);
    });
  }

  return loadPromise;
};
